<template>
  <div v-if="visible" class="confirm-modal-container">
    <div class="confirm-modal">
      <div class="header-bg"></div>
      <div class="close-btn" @click="handleClose"></div>
      <div class="message-text">{{ message }}</div>
      <a-divider />
      <div class="btn-group">
        <div class="btn" :class="confirmBtnStyle" @click="handleConfirm">
          {{ confirmText }}
        </div>
        <div class="btn" :class="cancelBtnStyle" @click="handleCancel">{{ cancelText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { buttonStyleEnum } from '@/components/common/ConfirmModal/ButtonStyleEnum'

export default {
  name: 'ConfirmModal',
  data() {
    return {
      visible: true,
      message: '',
      confirmBtnStyle: buttonStyleEnum.confirm,
      cancelBtnStyle: buttonStyleEnum.cancel,
      confirmText: '确定',
      cancelText: '取消'
    }
  },
  methods: {
    handleConfirm() {},
    handleCancel() {},
    handleClose() {}
  }
}
</script>

<style scoped lang="scss">
.confirm-modal-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  .confirm-modal {
    position: relative;
    width: 450px;
    background: #ffffff;
    border-radius: 32px;
    padding: 75px 40px 28px 40px;
    .header-bg {
      position: absolute;
      top: -70px;
      left: 50%;
      transform: translateX(-50%);
      width: 370px;
      height: 150px;
      background-image: url('../../../assets/login/authority-icon.png');
      background-size: 100% 100%;
    }
    .close-btn {
      position: absolute;
      top: 26px;
      right: 26px;
      width: 20px;
      height: 20px;
      background-image: url('../../../assets/common/close.png');
      background-size: 100% 100%;
      cursor: pointer;
    }
    .message-text {
      font-weight: 400;
      font-size: 20px;
      color: #333333;
      line-height: 28px;
    }
    .btn-group {
      display: flex;
      justify-content: space-between;
      gap: 28px;

      .btn {
        flex: 1;
        height: 54px;
        font-weight: 400;
        font-size: 17px;
        border-radius: 100px;
        text-align: center;
        line-height: 54px;
        cursor: pointer;
        &.cancel {
          background: #f6f6f6;
          color: #666666;
        }
        &.confirm {
          background: linear-gradient(270deg, #66adff 0%, #1976ff 100%);
          color: #ffffff;
        }
        &.error {
          background: #ff3c30;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
